import { FC } from 'react';
import classNames from 'classnames';
import { DefaultLayout, SupportContactForm } from '../../../components';

const AccountSupportPage: FC = () => {
  return (
    <DefaultLayout backTo="/" title="Haven't Found Your Answer?" className={classNames('account-support')}>
      <SupportContactForm />
    </DefaultLayout>
  );
};

export default AccountSupportPage;
